var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-light-primary font-weight-bolder mr-2",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ki ki-long-arrow-back icon-xs"}),_vm._v(_vm._s(_vm.$t("BACK"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }